module.exports = __webpack_public_path__ + "img/left_2.6eaed46f.png";